import { useQuery } from '@apollo/client';

import { BugTracker } from 'kb-shared/utilities/bugTracker';

import { QUERY_PREDICTED_ADDRESSES } from '../SignUpForm.graphql';
import { PredictedAddressesResponse } from '../SignUpForm.types';

export const usePredictAddresses = (input: string) => {
  const { data } = useQuery<PredictedAddressesResponse>(QUERY_PREDICTED_ADDRESSES, {
    variables: {
      input
    },
    skip: input.length < 5,
    onError: error => {
      BugTracker.notify(error, 'Failed to load address predictions');
    }
  });

  return { addressPredictions: data?.addressPrediction };
};
